import React from "react"
import { Typography } from "@material-ui/core"

import { EditableBlockDefaultProps } from "@/protocols/chatBotConstructor"

import BlockBodyItem from "@/pages/Admin/ChatBot/ChatBotConstructor/components/BlockBodyItem"
import BlockBodyItemTitle from "@/pages/Admin/ChatBot/ChatBotConstructor/components/BlockBodyItemTitle"
import BlockBodyContainer from "@/pages/Admin/ChatBot/ChatBotConstructor/components/BlockBodyContainer"
import BlockBodyItemInput from "@/pages/Admin/ChatBot/ChatBotConstructor/components/BlockBodyItemInput"
import BlockEditContainer from "@/pages/Admin/ChatBot/ChatBotConstructor/components/BlockEditContainer"
import BlockBodyEditMessageItem from "@/pages/Admin/ChatBot/ChatBotConstructor/components/BlockBodyEditMessageItem"

import RandomlyAttendanceEditor from "@/pages/Admin/ChatBot/ChatBotConstructor/Blocks/AssignAttendanceRandomlyBlock/RandomlyAttendanceEditor"

import {
	getNextChatBotRuleDescription,
	getCurrentAssignAttendanceBalancedOption
} from "@/utils/chatBot"

const AssignAttendanceRandomlyBlock: React.FC<EditableBlockDefaultProps> = (props) => {
	const {
		changeChatBotFlowContent,
		chatBotFlowBlockContent,
		nextChatBotFlowBlockRules,
		constructionResources,
		flowBlock,
		deleteChatBotFlowBlock
	} = props

	const handleChangeAttendance = () => {
		RandomlyAttendanceEditor.open({
			onSave: (chatBotFlowBlockContent) => changeChatBotFlowContent(chatBotFlowBlockContent),
			chatBotFlowBlockContent,
			constructionResources
		})
	}

	const getTitle = () => {
		const option = getCurrentAssignAttendanceBalancedOption(constructionResources, chatBotFlowBlockContent)

		if (option) {
			return option.name
		} else {
			return ""
		}
	}

	return (
		<BlockEditContainer
			name={flowBlock.title}
			onDelete={deleteChatBotFlowBlock}
		>
			<BlockBodyContainer>
				<BlockBodyEditMessageItem
					constructionResources={constructionResources}
					title="Mensagem"
					onSave={(buildedMessages) => changeChatBotFlowContent({ messagesToSend: buildedMessages })}
					messages={chatBotFlowBlockContent.messagesToSend}
				/>

				<BlockBodyItem>
					<BlockBodyItemTitle
						title="Distribuir entre"
					/>

					<BlockBodyItemInput
						text={getTitle() || ""}
						type="action"
						placeholder="Selecione uma forma de distribuição"
						onEdit={handleChangeAttendance}
					/>
				</BlockBodyItem>

				<BlockBodyItem>
					<BlockBodyItemTitle
						title="Condição de saída"
					/>

					{nextChatBotFlowBlockRules
						.map((nextChatBotFlowBlockRule) => (
							<Typography
								key={nextChatBotFlowBlockRule.id}
								variant="overline"
								color="textPrimary"
							>
								{getNextChatBotRuleDescription(nextChatBotFlowBlockRule)}
							</Typography>
						))
					}
				</BlockBodyItem>
			</BlockBodyContainer>
		</BlockEditContainer>
	)
}

export default AssignAttendanceRandomlyBlock
